import colors from '@/utils/colors';
const { manColor, womanColor, officeColor, notClassifiedColor } = colors;

export default {
  data() {
    return {
      genderObj: {
        manColor,
        womanColor,
        officeColor,
        notClassifiedColor,
        manLabel: this.$t('mixins.genderModel.label.man'),
        womanLabel: this.$t('mixins.genderModel.label.woman'),
        officeLabel: this.$t('mixins.genderModel.label.office'),
        notClassifiedLabel: this.$t('mixins.genderModel.label.notClassified'),
        manValue: 1,
        womanValue: 2,
        officeValue: 3,
      },
      genders: [
        'man',
        'woman',
        'office',
      ],
    };
  },
  methods: {
    getGenderObj(title) {
      return {
        color: this.genderObj[`${title}Color`],
        name: this.$t(`mixins.genderModel.label.${title}`),
        value: this.genderObj[`${title}Value`],
      };
    },
    getChannelColorNameAndIcon(title) {
      const manLabels = ['Homem', 'Man', 'Hombre'];
      const womanLabels = ['Mulher', 'Woman', 'Mujer'];
      const officeLabels = ['Marca', 'Organiza\u00e7\u00e3o', 'Organization', 'Organizaci\u00f3n'];

      if (manLabels.includes(title)) return this.getGenderObj('man');
      if (womanLabels.includes(title)) return this.getGenderObj('woman');
      if (officeLabels.includes(title)) return this.getGenderObj('office');
      return this.getGenderObj('notClassified');
    },
  },
};
